import { Comment } from 'types/comment';

import styles from './CommentReplyList.module.css';
import CommentReply from './CommentReply';
import { CommunityShotItem } from 'types/community';

type Props = {
  replies: Comment[];
  shotItem: CommunityShotItem;
  targetCommentId?: number;
};

export default function CommentReplyList(props: Props) {
  return (
    <div className={styles.CommentReplyList}>
      {props.replies.map((reply) => (
        <CommentReply
          shotItem={props.shotItem}
          key={'commentReply' + reply.commentId}
          reply={reply}
          targetCommentId={props.targetCommentId}
        />
      ))}
    </div>
  );
}
